<template>
    <el-row id="loading" v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <collectionBar :tags="tags" :subTitle="subTitle" :btnBack="true" @btnBackClick="btnBackClick" />
        <el-form label-width="120px" :model="uploadTaskForm" ref="ruleForm" id="ruleForm" hide-required-asterisk>
            <el-row>
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    选择继承任务
                </el-col>
                <el-col :span="10" style="margin-top:3px">
                    <el-select v-model="uploadTaskForm.inherit_task_id" size="small" placeholder="请选择数据采集任务"
                        style="width: 100%;">
                        <el-option v-for="item in taskList" :key="item.task_id" :label="item.task_name"
                            :value="item.task_id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="8" style="margin-top: 3px;margin-left:20px">
                    <el-button type="success" size="small" @click="btnSaveClick" :loading="genderBtnLoading">{{genderBtnText}}</el-button>
                </el-col>
            </el-row>
            <el-row style="height: 30px;margin-top: 30px">
                <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
                <el-col :span="2" style="line-height:30px">
                    <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
                    href="../../../static/提单情况厂家期初数据导入模版.xlsx" download="提单情况厂家期初数据.xlsx">下载</a>
                </el-col>
                <el-col :span="16" style="padding-top: 8px;">
                    <i class="el-icon-document" />
                    提单情况厂家期初数据导入模版.xlsx
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;margin-bottom: 10px">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    上传提单情况厂家期初数据
                </el-col>
                <el-col :span="10" style="margin-top:3px">
                    <div style="border: 1px solid #ededed;height: 30px;">
                        <span style="position: relative;top:8px;left:5px;font-size: 14px; padding-left: 10px;">{{ file1 }}</span>
                    </div>
                </el-col>
                <el-col :span="8" style="margin-top: 3px;margin-left:20px">
                    <el-upload class="upload-demo" ref="upload1" accept=".xlsx,.xls" action="" :file-list="fileList1"
                        :show-file-list="false" :on-change="handleChange1" :limit="1" :auto-upload="false">
                        <el-button slot="trigger" size="small"
                            style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
                        </el-button>
                        <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick1">导入数据
                        </el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-row style="height: 30px;margin-top: 30px">
                <el-col :span="4" style="line-height:30px;font-weight: bold">下载模板文件</el-col>
                <el-col :span="2" style="line-height:30px">
                    <a style="text-decoration: none;color: #ffff;" class="el-button el-button--primary el-button--mini"
                    href="../../../static/协同事项厂家期初数据导入模版.xlsx" download="协同事项厂家期初数据.xlsx">下载</a>
                </el-col>
                <el-col :span="16" style="padding-top: 8px;">
                    <i class="el-icon-document" />
                    协同事项厂家期初数据导入模版.xlsx
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px;margin-bottom: 30px">
                <el-col :span="4" style="line-height:30px;font-weight: bold">
                    上传协同事项厂家期初数据
                </el-col>
                <el-col :span="10" style="margin-top:3px">
                    <div style="border: 1px solid #ededed;height: 30px;">
                        <span style="position: relative;top:8px;left:5px;font-size: 14px;padding-left: 10px;">{{ file2 }}</span>
                    </div>
                </el-col>
                <el-col :span="8" style="margin-top: 3px;margin-left:20px">
                    <el-upload class="upload-demo" ref="upload2" accept=".xlsx,.xls" action="" :file-list="fileList2"
                        :show-file-list="false" :on-change="handleChange2" :limit="1" :auto-upload="false">
                        <el-button slot="trigger" size="small"
                            style="background-color: #7ed321;border: 1px solid #7ed321;color: white">选择文件
                        </el-button>
                        <el-button style="margin-left: 10px;" size="small" type="warning" @click="imortDataClick2">导入数据
                        </el-button>
                    </el-upload>
                </el-col>
            </el-row>
            <el-table :header-cell-style="{ 'color': 'black', 'font-size': '15px' }" :data="taskLogList" border
                style="width: 100%;margin-top: 20px" stripe>
                <el-table-column fixed type="index" width="55">
                </el-table-column>
                <el-table-column min-width="150" prop="task_name" label="当前任务名称">
                </el-table-column>
                <el-table-column min-width="150" prop="inherit_task_name" label="继承任务名称">
                </el-table-column>
                <el-table-column min-width="150" prop="alias" label="操作人">
                </el-table-column>
                <el-table-column min-width="150" prop="count" label="生成数量">
                </el-table-column>
                <el-table-column min-width="150" prop="timestamp" label="生成时间">
                </el-table-column>
            </el-table>
        </el-form>


        <!--    错误提示 提单-->
        <el-dialog :visible.sync="showModal_a" :show-close="false" width="900px" style="margin-top: -20px;">
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="downloadError">下载错误信息</el-button>
                        <el-button type="danger" size="small" @click="showModal_a = false">关闭</el-button>
                    </span>
                </div>
            </div>
            <el-table border :data="errorData1" stripe height="450px" style="width: 100%;margin-top: -20px;"
                header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75">
                </el-table-column>
                <el-table-column prop="sku_code" label="产品编码" min-width="150" sortable> </el-table-column>
                <el-table-column prop="sku_name" label="产品名称" min-width="100%" sortable> </el-table-column>
                <el-table-column prop="institution_code" label="医院编码" min-width="100%" sortable> </el-table-column>
                <el-table-column prop="institution_name" label="医院名称" min-width="150%" sortable> </el-table-column>
                <el-table-column prop="tidan" label="提单情况（编号）" min-width="140" sortable> </el-table-column>
                <el-table-column fixed="right" label="报错信息" width="240px">
                    <template slot-scope="scope">
                        <div>
                            <span style="font-size: 10px;color: red"
                                v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!--    错误提示 协同-->
        <el-dialog :visible.sync="showModal_b" :show-close="false" width="900px" style="margin-top: -20px;">
            <div slot="title">
                <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between">
                    <span style="color: #3998F7;font-size: 22px">错误提示</span>
                    <span>
                        <el-button type="primary" size="small" @click="downloadError2">下载错误信息</el-button>
                        <el-button type="danger" size="small" @click="showModal_b = false">关闭</el-button>
                    </span>
                </div>
            </div>
            <el-table border :data="errorData2" stripe height="450px" style="width: 100%;margin-top: -20px;"
                header-cell-class-name="headerStyle" :default-sort="{ prop: 'date', order: 'descending' }">
                <el-table-column type="index" :index="1" label="序号" style="font-size: 20px;color: #585757" width="75">
                </el-table-column>
                <el-table-column prop="sku_code" label="产品编码" min-width="150" sortable> </el-table-column>
                <el-table-column prop="sku_name" label="产品名称" min-width="100%" sortable> </el-table-column>
                <el-table-column prop="institution_code" label="医院编码" min-width="100%" sortable> </el-table-column>
                <el-table-column prop="institution_name" label="医院名称" min-width="150%" sortable> </el-table-column>
                <el-table-column prop="tidan" label="协同事项情况（编号）" min-width="140" sortable> </el-table-column>
                <el-table-column fixed="right" label="报错信息" width="240px">
                    <template slot-scope="scope">
                        <div>
                            <span style="font-size: 10px;color: red"
                                v-html="scope.row.message.replace(/！/g, '！\<br\/\>')"></span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </el-row>

</template>

<script>
import collectionBar from '../../../components/collectionBar'
import http from '../../../APIService/http'
import { export_json_to_excel } from "../../../vendor/Export2Excel";
import xlsx from 'xlsx'
import moment from "moment";

export default {
    name: "taskZhunru",
    data() {
        return {
            loadingText:"",
            loading: false,
            tags: ['数据采集任务', '任务概要'],
            subTitle: '',
            channelCheckList: [
                "INSTITUTION",
                "HCP",
                "RETAILSTORE",
                "DISTRIBUTOR",
                "CUSTOMTABLE"
            ],
            uploadTaskForm: {
                inherit_task_id: '',
            },
            collectProfile: {},
            taskList: [],
            taskLogList: [],

            file1: "",
            file2: "",
            fileList: [],
            fileList1: [],
            fileList2: [],
            excelData1: [],
            excelData2: [],
            errorData1: [],
            errorData2: [],
            showModal_a: false,
            showModal_b: false,
            
            genderBtnLoading:false,
            genderBtnText:"生成数据"
        }
    },


    components: {
        collectionBar,
    },
    created() {
        if (this.$route.params.task_id) {
            this.uploadTaskForm.inherit_task_id = this.$route.params.inherit_task_id
            this.collectProfile = JSON.stringify(this.$route.params)
            localStorage.setItem('collectProfile', this.collectProfile)
        } else {
            this.collectProfile = JSON.parse(localStorage.getItem('collectProfile'))
            this.uploadTaskForm.inherit_task_id = this.collectProfile.inherit_task_id
        }
        this.subTitle = this.collectProfile.task_name
        this.getCollectTask()
        this.getCollectTaskLog();
    },
    methods: {

        btnBackClick() {
            this.$router.push({ name: 'CollectionHome' })
        },
        async getCollectTask() {
            let loading2 = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    reference_obj: this.channelCheckList,
                    task_name: "",
                    start_date: '',
                    end_date: '',
                    limit: 20,
                    offset: 0
                }
                await http.post('/wapi/Collect/getCollectTask', data).then(res => {

                    console.log(res)
                    loading2.close()
                    if (res.success) {
                        if (res.data.result) {
                            console.log(res.data.result)
                            this.taskList = res.data.result.filter(item => item.task_id !== this.collectProfile.task_id);
                            this.taskList.unshift({
                                task_id: 'NONE',
                                task_name: '暂不选择继承任务,仅生成基础数据'
                            })
                        }
                    } else {
                        this.error(res.message)
                    }
                })
            } catch (e) {
                loading2.close()
            }
        },

        btnSaveClick() {

            if (!this.uploadTaskForm.inherit_task_id) {
                this.error("请选择继承任务")
                return;
            }

            this.$confirm('本操作会按照已选定的辖区，生成所有需要填写的数据行，请确定是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        task_id: this.collectProfile.task_id,
                        inherit_task_id: this.uploadTaskForm.inherit_task_id,
                    }
                    this.genderBtnText = "生成中";
                    this.genderBtnLoading = true;
                    http.post('/crm/web/collection//genderTaskInheirtData', data).then(res => {
                        console.log(res)
                        if (res.data.success) {
                            this.$message({
                                type: "success",
                                message: "生成成功"
                            })
                            this.genderTaskInheirtData_update({...data,timestamp:res.data.data.timestamp})
                            this.getCollectTaskLog();
                        } else {
                            this.error(res.data.msg)
                        }
                        this.genderBtnText = "生成数据";
                        this.genderBtnLoading = false;
                    })
                } catch (e) {
                    this.genderBtnText = "生成数据";
                    this.genderBtnLoading = false;
                }

            }).catch(() => {

            });

        },
        async genderTaskInheirtData_update(data) {
            try {
                console.log("genderTaskInheirtData_update:",data)
                await http.post('/crm/web/collection/genderTaskInheirtData_update', data).then(res => {
                
                    console.log("genderTaskInheirtData_update:",res)
                })
            } catch (e) {
                console.log("genderTaskInheirtData_update:",e)
            }
        },
        async getCollectTaskLog() {
            let loading2 = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            try {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id: this.collectProfile.task_id,
                }
                await http.post('/crm/web/collection/getTaskGenderDataLog', data).then(res => {

                    console.log(res)
                    loading2.close()
                    if (res.success) {
                        this.taskLogList = res.data;
                    } else {
                        this.error(res.message)
                    }
                })
            } catch (e) {
                loading2.close()
            }
        },


        /**上传方法 */

        async handleChange1(file, fileList) {
            this.loading = true
            this.$refs.upload1.clearFiles()
            this.loadingText = '文件解析中'
            let res = await this.getParsingFile(file.raw)

            setTimeout(() => {
                this.loading = false
                this.loadingText = '拼命加载中'
            }, 1000)
            if (!res.status) {
                this.$message.error(res.message)
                this.fileList1 = []
                return
            }

            console.log(res.data)
            if (res.data.length === 0 || res.data[0].length !== 5 || res.data[0][0].trim() !== '产品编码') {
                this.$message.error('模板错误，请选择正确的模板')
                this.fileList1 = []
                return false
            }
            if (res.data.slice(1).length === 0) {
                this.$message.error('导入数据必须大于0条')
                this.fileList1 = []
                return false
            }
            if (fileList.length !== 0 && res) {
                this.file1 = file.name
            }
            this.excelData1 = res.data
        },
        async handleChange2(file, fileList) {
            this.loading = true
            this.$refs.upload2.clearFiles()
            this.loadingText = '文件解析中'
            let res = await this.getParsingFile(file.raw)

            setTimeout(() => {
                this.loading = false
                this.loadingText = '拼命加载中'
            }, 1000)
            if (!res.status) {
                this.$message.error(res.message)
                this.fileList2 = []
                return
            }

            if (res.data.length === 0 || res.data[0].length !== 5 || res.data[0][0].trim() !== '产品编码') {
                this.$message.error('模板错误，请选择正确的模板')
                this.fileList2 = []
                return false
            }
            if (res.data.slice(1).length === 0) {
                this.$message.error('导入数据必须大于0条')
                this.fileList2 = []
                return false
            }
            if (fileList.length !== 0 && res) {
                this.file2 = file.name
            }
            this.excelData2 = res.data
        },


        async imortDataClick1() {
            if (this.excelData1.length === 0) {
                this.$message.error('请选择导入模板！')
                return false
            }
            this.loading = true
            this.loadingText = `正在导入数据0%(0/${this.excelData1.length - 1})`
            this.errData1 = ''
            this.record = []
            let herder = this.excelData1[0]
            let res = await this.importData1(herder, this.excelData1.slice(1), 0, 500, this.excelData1.length - 1)

            if (!res) {
                this.$message.error('导入失败')
                this.loading = false
                this.loadingText = '拼命加载中'
            } else {
                if (this.record.some((item) => item)) {
                    this.$message.success('导入成功')
                    this.loadingText = '拼命加载中'
                    this.loading = false
                    if (this.errData1.length > 0) {
                        this.showModal_a = true
                        this.errorData1 = this.errData1.slice(0, 100)
                    }
                } else {
                    this.$message.error('导入失败')
                    this.loading = false
                    this.loadingText = '拼命加载中'
                }
            }
        },
        async importData1(herder, excelData = [], page = 0, limit = 1000, size = 0) {
            try {
                if (page * limit >= size) {
                    return true
                }
                let data = {
                    progressNum: page * limit,
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id:this.collectProfile.task_id,
                    data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
                }

                let response = await http.post('/crm/excel/importCollection_CJTGTDQK', data)
                console.log("---",response)
                if (!response) {
                    return false
                }
                if (response.statusCode === 502) {
                    return await this.importData1(herder, excelData, page, limit, size)
                }
                this.loadingText =
                    '正在导入数据' +
                    (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
                let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
                this.loadingText += progressText

                if (response.success) {
                    this.record.push(true)
                    if (response.data) {
                        if (!this.errData1) {
                            this.errData1 = []
                        }
                        this.errData1 = [...this.errData1, ...response.data]
                    }
                } else {
                    this.record.push(false)
                }
                return await this.importData1(herder, excelData, page + 1, limit, size)
            } catch (e) {
                return false
            }
        },

        async imortDataClick2() {
            if (this.excelData2.length === 0) {
                this.$message.error('请选择导入模板！')
                return false
            }
            this.loading = true
            this.loadingText = `正在导入数据0%(0/${this.excelData2.length - 1})`
            this.errData2 = ''
            this.record = []
            let herder = this.excelData2[0]
            let res = await this.importData2(herder, this.excelData2.slice(1), 0, 500, this.excelData2.length - 1)

            if (!res) {
                this.$message.error('导入失败')
                this.loading = false
                this.loadingText = '拼命加载中'
            } else {
                if (this.record.some((item) => item)) {
                    this.$message.success('导入成功')
                    this.loadingText = '拼命加载中'
                    this.loading = false
                    if (this.errData2.length > 0) {
                        this.showModal_b = true
                        this.errorData2 = this.errData2.slice(0, 100)
                    }
                } else {
                    this.$message.error('导入失败')
                    this.loading = false
                    this.loadingText = '拼命加载中'
                }
            }
        },
        async importData2(herder, excelData = [], page = 0, limit = 1000, size = 0) {
            try {
                if (page * limit >= size) {
                    return true
                }
                let data = {
                    progressNum: page * limit,
                    user_id: this.$store.getters.getUser.user_id,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    task_id:this.collectProfile.task_id,
                    data: [herder, ...excelData.slice(page * limit, (page + 1) * limit)],
                }

                let response = await http.post('/crm/excel/importCollection_CJTGXTSX', data)
                if (!response) {
                    return false
                }
                if (response.statusCode === 502) {
                    return await this.importData2(herder, excelData, page, limit, size)
                }
                this.loadingText =
                    '正在导入数据' +
                    (((page + 1) * limit) / size > 1 ? '100%' : ((((page + 1) * limit) / size) * 100).toFixed(0) + '% ')
                let progressText = (page + 1) * limit >= size ? ` (${size} / ${size})` : ` (${(page + 1) * limit} / ${size})`
                this.loadingText += progressText

                if (response.success) {
                    this.record.push(true)
                    if (response.data) {
                        if (!this.errData2) {
                            this.errData2 = []
                        }
                        this.errData2 = [...this.errData2, ...response.data]
                    }
                } else {
                    this.record.push(false)
                }
                return await this.importData2(herder, excelData, page + 1, limit, size)
            } catch (e) {
                return false
            }
        },

        async getParsingFile(fileName) {
            return new Promise(function (resolve, reject) {
                //定义reader，存放文件读取方法
                let reader = new FileReader()

                //启动函数
                reader.readAsBinaryString(fileName)
                //onload文件读取成功
                reader.onload = function (e) {
                    //workbook存放excel的所有基本信息
                    let workbook = xlsx.read(e.target.result, { type: 'binary' })
                    xlsx.onprogress = function (e) { }
                    //定义sheetList中存放excel表格的sheet表，就是最下方的tab
                    let sheetList = workbook.SheetNames

                    //存放json数组格式的表格数据
                    let resultJson = []
                    if (sheetList.length > 1) {
                        reject({ status: false, message: '模板错误,不能有1个以上sheet' })
                    }
                    sheetList.forEach(function (y) {
                        resultJson = xlsx.utils.sheet_to_json(workbook.Sheets[y], { defval: '' })
                    })

                    if (resultJson.length === 0) {
                        resolve({ status: true, data: resultJson })
                    }
                    //取出表头
                    let tableHeader = Object.keys(resultJson[0])

                    //取出表数据
                    let importInfo = resultJson.map((item) => {
                        return tableHeader.map((v) => item[v])
                    })

                    importInfo = [tableHeader, ...importInfo]
                    resolve({ status: true, data: importInfo })
                }
                //文件读取失败
                reader.onerror = function (e) {
                    console.log("---1--",e)
                    reject({ status: false, message: '解析失败' })
                }
            })
        },


        downloadError() {
            try {
                this.loading = true;
                let tHeader = ["科室编码", "科室名称", "排序", "是否启用", "备注", "报错信息"];
                let names = ["project_code", "project_name", "sort", "status", "comments", "message"];
                let data = this.obj_to_arr(names, this.errData);
                this.loadingText = `正在下载错误数据0% (0 / ${data.length})`;
                this.downloadErrorExcel(tHeader, data, 0, 20000);
                //错误数据
                this.loading = false;
                this.loadingText = "拼命加载中";
            } catch (err) {
                this.loading = false;
                this.loadingText = "拼命加载中";
                this.$message.error("下载失败！");
            }
        },

        downloadError2() {
            try {
                this.loading = true
                let tHeader = [
                    '品类编码',
                    '品类名称',
                    '样品编码',
                    '样品名称',
                    '商品规格',
                    '生产企业',
                    '剂型',
                    '最小包装单位',
                    '考核价',
                    '是否启用',
                    '报错信息',
                ]
                let names = [
                    'product_code',
                    'product_name',
                    'sku_code',
                    'sku_name',
                    'specification',
                    'manufacturer',
                    'dosage_form_name',
                    'unit_name',
                    'unit_price',
                    'status',
                    'message',
                ]
                let data = this.obj_to_arr(names, this.errData2)
                this.loadingText = `正在下载错误数据0% (0 / ${data.length})`
                this.downloadErrorExcel(tHeader, data, 0, 20000)
                //错误数据
                this.loading = false
                this.loadingText = '拼命加载中'
            } catch (err) {
                this.loading = false
                this.loadingText = '拼命加载中'
                this.$message.error('下载失败！')
            }
        },
        obj_to_arr(names, data) {
            return data.map((item) => {
                let arr = [];
                names.forEach((name) => {
                    arr.push(item[name]);
                });
                return arr;
            });
        },
        downloadErrorExcel(header, data, page = 0, limit = 5000) {
            try {
                if (page * limit >= data.length) {
                    return true;
                }

                //错误数据
                let tHeader = header;
                let tData = data.slice(page * limit, (page + 1) * limit);
                export_json_to_excel({
                    header: tHeader,
                    data: tData,
                    filename: "科室导入错误数据" + (!page ? "" : page),
                });
                this.loadingText = `正在下载错误数据0% (${(page + 1) * limit} / ${data.length})`;
                this.downloadErrorExcel(header, data, page + 1, limit);
            } catch (err) {
                this.loading = false;
                this.loadingText = "拼命加载中";
                this.$message.error("下载失败！");
            }
        },

    },

}
</script>

<style scoped>
#collection>>>.el-tag.el-tag--info {
    background: #FF9901;
    color: #FFFFFF;
    border: none;
}

#collection>>>.el-tag.el-tag--info .el-tag__close {
    display: none;
}

#collection>>>.el-form-item__label {
    font-size: 14px;
    color: black;
    font-weight: bold;
}

#collection>>>.collection_star label:after {
    content: '*';
    color: #F56C6C;
    margin-left: 4px;
}
</style>


// WEBPACK FOOTER //
// src/pages/collection/components/TaskZhunru.vue